export default function generateSlug(node) {
    return node.slug ? node.slug + '/' : node.title.replace(/\s+/gi, '-').toLowerCase() + '/';
}